import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from './AuthContext';
import AuthCard from './AuthCard';
import LoginForm from './LoginForm';
import '../styles/Auth.css';

// Page /login. `?next=/chemin` : page où revenir une fois connecté (chemin interne uniquement).
export default function LoginPage() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const { user } = useAuth();
    const next = params.get('next');
    const target = next && next.startsWith('/') && !next.startsWith('//') ? next : '/';

    if (user) {
        return (
            <AuthCard title="Déjà connecté" subtitle={`Vous êtes connecté en tant que ${user.name} (${user.email}).`}>
                <button type="button" className="auth-btn auth-btn--primary" onClick={() => navigate(target)}>
                    Continuer
                </button>
            </AuthCard>
        );
    }

    return (
        <AuthCard title="Connexion" subtitle="Connectez-vous avec votre compte Walter.">
            <LoginForm onSuccess={() => navigate(target, { replace: true })} />
        </AuthCard>
    );
}
